import { GoCode } from 'react-icons/go';
import { MdCampaign, MdOutlineAutoAwesomeMosaic } from 'react-icons/md';

export const PASSING_STATUSES = new Set([
  'Rendering Verified',
  'CTA Verified',
  'Test Completed',
]);

export const HEALTH_VARIANTS = {
  healthy: 'success',
  warning: 'warning',
  unhealthy: 'danger',
  unknown: 'secondary',
} as const;

export const SERIES_COLORS = [
  '#165177',
  '#a50135',
  '#198754',
  '#f08c00',
  '#6f42c1',
  '#0b7285',
  '#dc3545',
  '#6c757d',
  '#20c997',
  '#fd7e14',
];

export const SOURCE_LABELS: Record<string, string> = {
  creativeTests: 'Mosaic. (Managed Flow)',
  onDemandAdsureTests: 'On Demand',
  programmaticCreativeTests: 'SSP',
};

export const SOURCE_STYLES = {
  creativeTests: {
    color: '#00857a',
    Icon: MdOutlineAutoAwesomeMosaic,
  },
  onDemandAdsureTests: {
    color: '#f08c00',
    Icon: MdCampaign,
  },
  programmaticCreativeTests: {
    color: '#165177',
    Icon: GoCode,
  },
} as const;

export const DEFAULT_MONITORING_SOURCES = [
  'creativeTests',
  'onDemandAdsureTests',
  'programmaticCreativeTests',
];
